import { faEthereum } from '@fortawesome/free-brands-svg-icons';

import type { Props as PaymentMethodIconProps } from '..';
import { PaymentMethodIcon } from '..';

type Props = Pick<PaymentMethodIconProps, 'size'>;

export const EthWalletIcon = ({ size }: Props) => {
  return (
    <PaymentMethodIcon
      size={size}
      backgroundColor="var(--c-blue-400)"
      color="var(--c-white)"
      icon={faEthereum}
    />
  );
};
